import { render, staticRenderFns } from "./scroll-up-btn.vue?vue&type=template&id=555406b8&scoped=true"
import script from "./scroll-up-btn.vue?vue&type=script&lang=js"
export * from "./scroll-up-btn.vue?vue&type=script&lang=js"
import style0 from "./scroll-up-btn.vue?vue&type=style&index=0&id=555406b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555406b8",
  null
  
)

export default component.exports